import React, { createContext, useCallback, useMemo, useState } from 'react';
import { Data } from '../data/Data';
import { useLotsCommerciaux } from './lotCommercialContext';
import { useNotificationsManager } from './notificationContext';

const StadeContext = createContext();
const StadeManagerContext = createContext();

export const StadeContextProvider = ({ children }) => {

    const { dismiss, extractErrorMessages, inform } = useNotificationsManager();
    const { idOperationActive, idLotCommercialActif } = useLotsCommerciaux();

    const [allStades, setAllStades] = useState([]);
    const [loaded, setLoaded] = useState([]);

    const loadStades = useCallback((idOperation, idLotCommercial) => {
        const id = inform("Chargement des stades d'avancement...");

        Data._getStades(idOperation, idLotCommercial).then(response => {
            if (response.codeRetour === 0) {
                const objet = response.reponseAPIobjet;
                let stades = objet.stades || [];
                setAllStades(prevStades => {
                    const merged = [...prevStades, ...stades];
                    return merged;
                });
                setLoaded(prevLoadedIdOperations => [...prevLoadedIdOperations, { idOperation, idLotCommercial }]);
            }
            else extractErrorMessages(response);

            dismiss(id);
        });
    }, [dismiss, extractErrorMessages, inform]);

    const stades = useMemo(() => {
        if (!idOperationActive || !idLotCommercialActif) return [];
        const alreadyLoaded = loaded.some(item => item.idOperation === idOperationActive && item.idLotCommercial === idLotCommercialActif);
        if (!alreadyLoaded) {
            loadStades(idOperationActive, idLotCommercialActif);
            return [];
        }
        else return allStades.filter(stade => stade.idOperation === idOperationActive && stade.idLotCommercial === idLotCommercialActif);
    }, [allStades, idOperationActive, idLotCommercialActif, loadStades, loaded]);

    const resetStades = useCallback(() => {
        setAllStades([]);
        setLoaded([]);
    }, []);

    const value = useMemo(
        () => ({ stades }),
        [stades]
    );

    const managerValue = useMemo(
        () => ({ resetStades }),
        [resetStades]
    );

    return <StadeManagerContext.Provider value={managerValue}>
        <StadeContext.Provider value={value}>
            {children}
        </StadeContext.Provider>
    </StadeManagerContext.Provider>;

};

export const useStades = () => {
    const data = React.useContext(StadeContext);
    if (data === undefined) throw new Error();
    const { stades } = data;
    return { stades };
};

export const useStadesManager = () => {
    const manager = React.useContext(StadeManagerContext);
    if (manager === undefined) throw new Error();
    const { resetStades } = manager;
    return { resetStades };
};